// extracted by mini-css-extract-plugin
export default {"modalBody":"_f807d2ac"};